// extracted by mini-css-extract-plugin
export var cardLayout = "_a3-1";
export var paginationContainer = "_a3-0";